import {IAutoOrderAccountSettings} from './ao-account-settings.interface';

//#region DEFAULT _DEFAULT_AUTO_ORDER_ACCOUNT_SETTINGS
export const _DEFAULT_AUTO_ORDER_ACCOUNT_SETTINGS: Readonly<IAutoOrderAccountSettings> = {
  growth: 10,
  monthsHistory: 3,
  period: 2,
  stockDays: 30,
} as const;
//#endregion

